export default {
  Contact: 'Contact',
  Contact_information: 'Contact information',
  Email: 'Email',
  Full_name: 'Full name',
  Telephone_contact: 'Telephone contact',
  contactWithUs: 'Get in contact with us',
  Message: 'Message',
  SEND_MESSAGE: 'SEND MESSAGE',


}